import type {ClauseStatus, MonitorCallout, PriceClause} from "../types/monitorTypes";
import {LOCALE} from '~/pages/category-profile/domain/locale';

const MONTH = new Intl.DateTimeFormat(LOCALE, {month: 'short', year: 'numeric'});
const DAY = new Intl.DateTimeFormat(LOCALE, {day: 'numeric', month: 'short', year: 'numeric'});

export const signedPct = (v: number | null | undefined, digits = 1) =>
    v === null || v === undefined ? '—' : `${v > 0 ? '+' : ''}${v.toFixed(digits)}%`;
export const monthOf = (iso: string | null) => (iso ? MONTH.format(new Date(iso)) : '—');
export const dayOf = (iso: string | null) => (iso ? DAY.format(new Date(iso)) : '—');

export const STATUS_LABEL: Record<ClauseStatus, string> = {
    indexed: 'Follows the index', below_trigger: 'Below trigger', capped: 'At the cap', floored: 'At the floor',
    no_data: 'No index data',
};

/** One line per callout (spec 4.4: announced increase, drivers down this quarter, revisions coming up). */
export function calloutText(c: MonitorCallout): {severity: 'warning' | 'success' | 'info'; text: string} {
    switch (c.kind) {
        case 'announced_above_index':
            return {severity: 'warning', text: `${c.supplier} announced ${signedPct(c.announced)} for ${dayOf(c.window)}; `
                    + `the index supports ${signedPct(c.implied)}. Challenge the difference.`};
        case 'announced_in_line':
            return {severity: 'info', text: `${c.supplier} announced ${signedPct(c.announced)} for ${dayOf(c.window)}, `
                    + `in line with the index (${signedPct(c.implied)}).`};
        case 'revision_due':
            return {severity: 'info', text: `${c.supplier}: price revision on ${dayOf(c.window)}; `
                    + `the index supports ${signedPct(c.implied)}.`};
        case 'driver_down':
            return {severity: 'success', text: `${c.driver} is down ${signedPct(c.change)} this quarter: `
                    + `ask for a decrease at the next revision.`};
    }
}

export function capFloor(c: PriceClause): string {
    if (c.capPct === null && c.floorPct === null) return 'None';
    return `${c.capPct === null ? '—' : `+${c.capPct}%`} / ${c.floorPct === null ? '—' : `−${c.floorPct}%`}`;
}
